/** @odoo-module **/

import { Component, useState, onMounted } from "@odoo/owl";

const WP_SITE_ID = 112709523;
const FALLBACK_POST_IMG = "https://schoolsindustryblog.files.wordpress.com/2018/10/vectorstock_19911069.jpg?w=900";

export class WPCResourcesPage extends Component {
    static template = "wpc_portal.wpc_portal_root_home_resources_component";
    static components = {};

    setup() {
        this.state = useState({
            tab: "documents",
            documents: null,
            blog: null,
            videos: null,
            loading: {
                documents: false,
                blog: false,
                videos: false,
            },
            error: {
                documents: null,
                blog: null,
                videos: null,
            },
        });

        onMounted(() => {
            this.fetchDocuments();
        });
    }

    switchTab(tab) {
        this.state.tab = tab;
        if (tab === "documents" && !this.state.documents && !this.state.loading.documents) {
            this.fetchDocuments();
        } else if (tab === "blog" && !this.state.blog && !this.state.loading.blog) {
            this.fetchBlog();
        } else if (tab === "videos" && !this.state.videos && !this.state.loading.videos) {
            this.fetchVideos();
        }
    }

    async fetchDocuments() {
        this.state.loading.documents = true;
        this.state.error.documents = null;
        try {
            const res = await fetch("/api/resources/documents");
            if (!res.ok) throw new Error("Failed to fetch documents");
            this.state.documents = await res.json();
        } catch (e) {
            console.error("Error fetching documents:", e);
            this.state.error.documents = "Failed to load documents.";
        }
        this.state.loading.documents = false;
    }

    async fetchBlog() {
        this.state.loading.blog = true;
        this.state.error.blog = null;
        try {
            const res = await fetch(
                `https://public-api.wordpress.com/rest/v1.1/sites/${WP_SITE_ID}/posts`
            );
            if (!res.ok) throw new Error("Failed to fetch blog");
            const data = await res.json();
            this.state.blog = data.posts || [];
        } catch (e) {
            console.error("Error fetching blog:", e);
            this.state.error.blog = "Failed to load blog posts.";
        }
        this.state.loading.blog = false;
    }

    async fetchVideos() {
        this.state.loading.videos = true;
        this.state.error.videos = null;
        try {
            const res = await fetch("/api/resources/videos");
            if (!res.ok) throw new Error("Failed to fetch videos");
            this.state.videos = await res.json();
        } catch (e) {
            console.error("Error fetching videos:", e);
            this.state.error.videos = "Failed to load videos.";
        }
        this.state.loading.videos = false;
    }

    formatDate(dateStr) {
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }

    getFileIcon(filename) {
        if (!filename) return "bi bi-file-earmark";
        const ext = filename.split(".").pop().toLowerCase();
        const icons = {
            pdf: "bi bi-file-earmark-pdf-fill",
            doc: "bi bi-file-earmark-word-fill",
            docx: "bi bi-file-earmark-word-fill",
            xls: "bi bi-file-earmark-excel-fill",
            xlsx: "bi bi-file-earmark-excel-fill",
            ppt: "bi bi-file-earmark-ppt-fill",
            pptx: "bi bi-file-earmark-ppt-fill",
            png: "bi bi-file-earmark-image-fill",
            jpg: "bi bi-file-earmark-image-fill",
            jpeg: "bi bi-file-earmark-image-fill",
            zip: "bi bi-file-earmark-zip-fill",
        };
        return icons[ext] || "bi bi-file-earmark-fill";
    }

    openVideo(videoId) {
        window.open("https://youtu.be/" + videoId, "_blank");
    }
}
